import React, { useState } from "react";
interface Props {
  label?: string;
  placeholder?: string;
  validate?: (value: string) => string | null; // return error message or null
  onSubmit?: (value: string) => void;
}
const TextInputWithValidation: React.FC<Props> = ({
  label = "Name",
  placeholder = "Enter your name",
  validate = (v) => {
    if (!v.trim()) return "This field is required.";
    return null;
  },
  onSubmit = (v) => console.log("Submitted:", v),
}) => {
  const [value, setValue] = useState("");
  const [touched, setTouched] = useState(false);
  const error = validate(value);
  const isValid = !error;
  return (
    <form
      className="max-w-lg w-full  border border-gray-200 rounded-lg p-4 shadow-sm"
      onSubmit={(e) => {
        e.preventDefault();
        setTouched(true);
        if (isValid) onSubmit(value.trim());
      }}
      noValidate
    >
      <label
        htmlFor="text-input"
        className="block text-sm font-medium text-gray-700 mb-1"
      >
        {label}
      </label>
      <div className="relative">
        <textarea
          id="text-input"
          type="text"
          value={value}
          placeholder={placeholder}
          onChange={(e) => setValue(e.target.value)}
          onBlur={() => setTouched(true)}
          className={`w-full px-3 py-2 rounded-md border transition focus:outline-none
            ${
              touched && error
                ? "border-red-500 focus:ring-2 focus:ring-red-200"
                : "border-gray-300 focus:ring-2 focus:ring-blue-200"
            }
            text-gray-900 placeholder-gray-400 bg-white`}
          aria-invalid={touched && !!error}
          aria-describedby="input-help input-error"
        />
        {/* Optional right icon or character counter */}
        <div className="absolute inset-y-0 right-2 flex items-center">
          <span className="text-xs text-gray-400">{value.trim().length}</span>
        </div>
      </div>
      {touched && error &&
        <p id="input-error" className="mt-1 text-xs text-red-600">
          {error}
        </p>
   }
      <div className="mt-4 flex gap-2">
        <button
          type="submit"
          disabled={!isValid}
          className={`inline-flex items-center justify-center px-4 py-2 rounded-md text-sm font-semibold
            ${
              isValid
                ? "bg-blue-600 text-white hover:bg-blue-700"
                : "bg-gray-200 text-gray-500 cursor-not-allowed"
            }
            transition focus:outline-none focus:ring-2 focus:ring-blue-300`}
        >
          Submit
        </button>
        <button
          type="button"
          onClick={() => {
            setValue("");
            setTouched(false);
          }}
          className="inline-flex items-center justify-center px-4 py-2 rounded-md text-sm font-semibold
            bg-white text-gray-700 border border-gray-300 hover:bg-gray-50 transition
            focus:outline-none focus:ring-2 focus:ring-gray-300"
        >
          Reset
        </button>
      </div>
    </form>
  );
};
export default TextInputWithValidation;